// extracted by mini-css-extract-plugin
export default {"list":"ListCard_list__6J8xR","title":"ListCard_title__YqVEd"};